//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import { mapState } from "vuex";
import { common, commonApi } from "@/common/index";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      activeIndex: 0, // 0 普通充值 1 USDT充值
      swiperOption: {
        preventClicks: false,
        slidesPerView: 2,
        slidesPerColumn: 3,
        spaceBetween: 10,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        on: {
          tap: () => {
            const index = this.$refs.depositeSwiper.swiper.clickedIndex;

            if (index >= 0) {
              this.selectPayType = this.getDepositeWay[index];
            }
          },
        },
      },
      USDTRate: "",
      typeList: [],
      payConfigList: [],
      titleExtend: [],
      selectPayType: null,
      selectPayConfig: {},
      amount: "", // 充值金额
      loading: false,
      showName: false,
      showPhone: false,
    };
  },
  activated() {
    this.checkPermission();
  },
  mounted() {
    this.init();
    this.getUSDTRate();
  },
  computed: {
    ...mapState({
      UUID: (state) => state.UUID,
      userInfo: (state) => state.userInfo,
    }),
    getDepositeWay() {
      return this.typeList[this.activeIndex]
        ? this.typeList[this.activeIndex].list
        : [];
    },
    getUSDTAmount() {
      return (this.amount / this.USDTRate).toFixed(4);
    },
  },
  watch: {
    selectPayType(val) {
      if (val) {
        this.payConfigList = [];
        this.selectPayConfig = {};
        this.getPayTypeConfig(val);
      }
    },
  },
  methods: {
    checkPermission() {
      const { nameValid, mobileValid } = this.userInfo.userInfo;
      if (!nameValid) {
        this.showName = true;
      } else if (!mobileValid) {
        this.showPhone = true;
      }
    },
    init() {
      const UUID =
        this.$store.state.UUID === ""
          ? this.$Cookies.get("UUID")
          : this.$store.state.UUID;
      commonApi.PAY.getNewPayType(UUID).then((data) => {
        this.typeList = data || [];
        this.changeDepositeType(0);
      });
    },
    getUSDTRate() {
      commonApi.HOMEAFTER.getusdtRate().then((data) => {
        this.USDTRate = data || "0";
      });
    },
    changeDepositeType(v) {
      this.activeIndex = v;
      this.selectPayType = this.getDepositeWay[0];
    },
    changeDepositeWay(config) {
      this.selectPayType = config;
    },

    getPayTypeConfig(item) {
      const params = {
        UUID: this.UUID,
        payCode: item.payCode,
        deviceType: "mobile",
      };

      commonApi.PAY.getPayConfig(params)
        .then((res) => {
          this.payConfigList = res.payConfigList;
          this.handleSelectPayConfig(res.payConfigList[0]);
        })
        .catch((err) => {
          this.$toast({
            message: err.message || err.msg,
            icon: "warning",
          });
        });
    },

    handleSelectPayConfig(item) {
      this.selectPayConfig = item;
    },

    handleDeposite() {
      if (!this.selectPayType || !this.selectPayConfig.id) {
        this.$vux.toast.show({
          text: this.$t("ValidTips.noRechargeRoad"),
          type: "cancel",
        });
        return;
      }

      if (!this.amount || this.amount <= 0) {
        this.$vux.toast.show({
          text: this.$t("ValidTips.noRechargeAmount"),
          type: "cancel",
        });
        return;
      }

      const params = {
        payDomain: "/api/indexpay/apppay_gateway", // newDepositUrl
        amount: this.amount,
        payType: this.selectPayConfig.payType,
        payConfigId: this.selectPayConfig.id,
        remark: this.selectPayConfig.remark,
        userId: this.UUID,
      };
      common.newDepositUrl(params); //newDepositUrl depositUrl
    },
    passCancel() {
      this.$router.go(-1);
    },
    phoneConfirm() {
      this.$router.push({
        path: "/My/AccountManat/mobileAuth",
      });
    },
    nameConfirm() {
      this.$router.push({
        path: "/My/AccountManat/VerifiedAuth",
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/funds/deposite.vue